var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class PDFViewSDKClient {
  constructor(scope) {
    this.window = scope;
    this.readyPromise = new Promise((resolve) => {
      if (this.window.AdobeDC) {
        resolve();
      } else {
        this.window.document.addEventListener("adobe_dc_view_sdk.ready", () => {
          resolve();
        });
      }
    });
  }
  ready() {
    return this.readyPromise;
  }
  previewFileWithURL(config, fileData, viewerConfig) {
    const { url, fileName } = fileData;
    this.adobeDCView = new this.window.AdobeDC.View(config);
    return new Promise((resolve) => {
      this.adobeDCView.previewFile(
        {
          content: {
            location: {
              url
            }
          },
          metaData: {
            fileName
          }
        },
        __spreadProps(__spreadValues({}, viewerConfig), {
          showLeftHandPanel: false,
          showAnnotationTools: false,
          enableLinearization: true
        })
      );
      resolve();
    });
  }
  previewFileWithBlob(config, fileData, viewerConfig) {
    const { url, fileName } = fileData;
    return new Promise((resolve, reject) => {
      fetch(new Request(url)).then((response) => response.blob()).then((blob) => {
        this.adobeDCView = new this.window.AdobeDC.View(config);
        this.adobeDCView.previewFile(
          {
            content: {
              promise: Promise.resolve(blob.arrayBuffer())
            },
            metaData: {
              fileName
            }
          },
          __spreadProps(__spreadValues({}, viewerConfig), {
            showLeftHandPanel: false,
            showAnnotationTools: false
            // enableLinearization: true,
          })
        );
        resolve();
      }).catch(reject);
    });
  }
  registerEventsHandler(eventsHandler) {
    this.adobeDCView.registerCallback(
      this.window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
      (event) => {
        eventsHandler(event.type);
      },
      {}
    );
  }
}

export { PDFViewSDKClient };
//# sourceMappingURL=pdfViewSDKClient.js.map
